import emojiRegex from "emoji-regex";


const Constant = {
    BASE_URL: process.env.REACT_APP_BASE_URL,
    REGEX: {
        ALPHANUMERIC: /^[a-zA-Z0-9\s\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u024F]+$/i,
        WEBSITEURL: /^(https?:\/\/)?(www\.)?[a-zA-Z0-9\-\.]+\.[a-zA-Z]{2,}\/?$/,
        EMAIL: /^$|^[a-zA-Z0-9\u00C0-\u024F\u1E00-\u1EFF_%+-][a-zA-Z0-9\u00C0-\u024F\u1E00-\u1EFF._%+-]*@[a-zA-Z0-9.-]+\.(?:[a-zA-Z\u00C0-\u024F\u1E00-\u1EFF]{2}|com|org|net|edu|gov|mil|biz|info|mobi|name|aero|asia|jobs|museum)$/i,
        PASSWORD: /^[^\s\uD83C-\uDBFF\uDC00-\uDFFF]+$/,
        NAME: /^[a-zA-ZÀ-ÖØ-öø-ÿ'-]+$/,
        LOWERCASE: /[a-z]/,
        UPPERCASE: /[A-Z]/,
        NUMBER: /[0-9]/,
        SPECIALCHARACTERS: /[!@#$%^&*)(+=._-]/g,
        EMOJI: emojiRegex(),
        TOWNS: /^[a-zA-Z ,]+$/,
        GPXSTARTLAT: /^(-?([1-8]?[0-9]|90))(\.\d{1,6})?$/,
        GPXSTARTLNG: /^(-?((1[0-7]?[0-9]|180)|[1-9]?[0-9]))(\.\d{1,6})?$/,
        // DECIMAL: /^(\d+(\.\d{1,2})?)?$/,
    },
    LOCALSTORAGEKEYS: {
        ACCESSTOKEN: 'accessToken',
        REFRESHTOKEN: 'refreshToken',
    },
    GENERALKEYS: {
        ADD: 'add',
        DISABLE: 'disable',
        EDIT: 'edit',
        DELETE: 'delete',
    }
};
export default Constant;
